import {
  withFormError,
  propertyIs,
} from '@bingads-webui-campaign-react/form-error';
import React from 'react';
import {
  FormErrorBeaconAdapter, ValidationBeaconAdapter,
} from '@bingads-webui-campaign-react/error-handling';
import { withAttentionBeacon } from '@bingads-webui-campaign-react/attention-beacon';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';
import { WebExclusions } from './web-exclusions';

export const webExclusionPropertyVal = propertyIs('webExclusions');

export const ServerValidatedWebExclusions = withAttentionBeacon(
  withFormError(WebExclusions, { showError: false }),
  { Adapters: [FormErrorBeaconAdapter, ValidationBeaconAdapter] }
);

const WebExclusionsInternal = ({
  updateValidation,
  parentData,
  level,
  ...rest
}) => {
  const onChange = (exclusionsData, type) => {
    const keyName = level === ScopeLevel.Campaign ? 'campaignExclusions' : 'adgroupExclusions';
    const patchExclusions = {
      exclusions: {
        ...(parentData.exclusions || {}),
        [keyName]: {
          ...(parentData.exclusions && parentData.exclusions[keyName] ? parentData.exclusions[keyName] : {}),
          [type]: exclusionsData,
        },
      },
    };

    updateValidation([], patchExclusions);
  };

  return (
    <WebExclusions
      setExclusionsCallback={onChange}
      level={level}
      {...rest}
    />
  );
};

const WebExclusionsWithValidation = withCustomValidation(WebExclusionsInternal);

export const ServerValidatedWebExclusionsWithValidation = withAttentionBeacon(
  withFormError(WebExclusionsWithValidation, { showError: false }),
  { Adapters: [FormErrorBeaconAdapter, ValidationBeaconAdapter] }
);
